module.exports = __webpack_public_path__ + "static/media/banner-sports-mobile.55ec881c.jpg";